module.exports = __webpack_public_path__ + "img/registered.71d2a5aa.svg";